import script from "./ToastDialog.vue?vue&type=script&setup=true&lang=js"
export * from "./ToastDialog.vue?vue&type=script&setup=true&lang=js"

import "./ToastDialog.vue?vue&type=style&index=0&id=6e2b9c85&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-6e2b9c85"]])

export default __exports__